/**
 * Mount or unmount a `children` based on `mount`
 */
const Mountable = ({ mount, children }: { mount: boolean; children: React.ReactNode }) => {
    return mount ? <>{children}</> : null;
};

export default Mountable;
